<div class="transport-registration-instructions">

  @if (instructionsForm) {
    @if (selectedInstruction == null) {
      <form [formGroup]="instructionsForm" class="form">
        <div class="instructions-list">
          @for (instruction of instructions; track instruction; let i = $index) {
            <div formArrayName="instructions" class="instruction"
              >
              <div class="instruction-layout">
                <div class="main-column">
                  <div class="title">
                    <sc-dictionary-label [dictionaryKey]="instruction.titleDictionaryKey"></sc-dictionary-label>
                  </div>
                  <div class="description">
                    <sc-dictionary-label [dictionaryKey]="instruction.descriptionDictionaryKey"></sc-dictionary-label>
                  </div>
                  <div class="checkbox">
                    <mat-checkbox formControlName="{{i}}">
                      <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-instructions.label.read"></sc-dictionary-label>
                    </mat-checkbox>
                  </div>
                  @if (instructions != null && instructions.length > 0) {
                    <p class="hint">
                      @if (!instruction.checked) {
                        <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-instructions.hint"></sc-dictionary-label>
                      }
                    </p>
                  }
                </div>
                <div class="right-column">
                  <div class="right-column-layout">
                    <div class="more action" (click)="showInstructionDetails(instruction)" matRipple>
                      <div class="action-layout">
                        <i class="fa-thin fa-file"></i>
                        <div class="label">
                          <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-instructions.label.showmore"></sc-dictionary-label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="instruction-separator">
                <div class="instruction-separator-visual"></div>
              </div>
            </div>
          }
        </div>
      </form>
    }
  }

  @if (selectedInstruction != null) {
    <div class="instrution-details">
      <button mat-flat-button (click)="hideInstructionDetails()">
        <sc-icon iconClass="fa-chevron-left"></sc-icon>
      </button>
      <div class="title">
        <sc-dictionary-label [dictionaryKey]="selectedInstruction.titleDictionaryKey"></sc-dictionary-label>
      </div>
      <div class="content"
        [innerHTML]=" ''|translate:[selectedInstruction.textDictionaryKey, translationService.language, translationService.revision]| trustHtml">
      </div>
    </div>
  }

</div>
